var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-brand-page',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"dialog"},[_c('c-password-reset-request-card')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }